import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import * as Fathom from 'fathom-client';
import { FATHOM_ID } from 'tvm-config';

interface UseFathomOptions {
  trackPageView?: boolean;
}

export function useFathom({ trackPageView }: UseFathomOptions = {}) {
  const router = useRouter();
  const isInitialized = useRef(false);
  const localInitRef = useRef(false);

  useEffect(() => {
    if (!isInitialized.current) {
      Fathom.load(FATHOM_ID);
      isInitialized.current = true;
    }

    if (trackPageView && !localInitRef) {
      localInitRef.current = true;

      const handleRouteChange = () => {
        Fathom.trackPageview();
      };

      router.events.on('routeChangeComplete', handleRouteChange);

      Fathom.trackPageview();

      return () => {
        router.events.off('routeChangeComplete', handleRouteChange);
      };
    }
  }, [router.events, trackPageView]);

  return Fathom;
}
